export const GOOGLE_LOGIN = '/auth/google-login';
export const LOGIN = '/auth/login/';
export const SIGNUP = '/auth/signup/';
export const FORGET_PASSWORD = '/auth/forget-password/';
export const RESET_PASSWORD = '/auth/reset-password/';
export const SET_PASSWORD = '/auth/set-password/';
export const TRENDING_HASHTAGS = '/posts/generate-hashtags-from-weekly-trends';
export const GENERATE_QUICK_POST = '/posts/generate-quick-post';
export const GET_PROFILE = '/profile/business-details';
export const POST_BUSINESS_PROFILE = '/update-profile/';
export const SCORM_UPLOAD = '/scorm-files/upload/';
export const SCORM_FILE_DETAILS = (id) => `/scorm-files/${id}/`;
export const SCORM_LIST = `/scorm-files/`;
export const SCORM_LIST_SORT_BY_TEAMS_APPS = `${SCORM_LIST}sort-by-teams-apps`;
export const SCORM_LIST_FILES = (id) => `/scorm-files/${id}/list_files/`;
export const SCROM_FILE_CONTENT_PREVIEW = (fileId) => `/scorm-files/${fileId}/preview-content`;
export const SCORM_START_CONTENT_EXTRACTION = '/content-extractions/';
export const CONTENT_EXTRACTION_PUBSUB_NEGOTIATE = '/content-extractions/pubsub-negotiate';
export const SCORM_DOWNLOAD_CONTENT = '/scorm-files/download-content/';
export const CONTENT_EXTRACTIONS = (page = 1) => `/content-extractions/?page=${page}`;
export const REFRESH_TOKEN = '/auth/refresh/';
export const SCORM_STATS = '/scorm-files/stats';
export const CONTENT_EXTRACTION_RESTART = (extraction_id) => `/content-extractions/${extraction_id}/restart/`;
export const API_KEYS = '/expose/api-keys/';
export const DELETE_EXTRACTION_ROUTE = (id) => `/content-extractions/${id}/`;
export const DOWNLOAD_EXTRACTION_ROUTE = (extraction_id) =>
    `/content-extractions/${extraction_id}/download-extracted-contents/`;
export const API_USAGE_STATS_BY_API_KEY = '/expose/api-usage-stats/timeline';
export const API_USAGE_STATS_BY_ENDPOINT = '/expose/api-usage-stats/by-endpoint';

// Subscription Routes
export const GET_ACTIVE_SUBSCRIPTION = '/subscriptions/get-active-subscription/';
export const REQUEST_SUBSCRIPTION_ACTIVATION = '/subscriptions/request-activation/';

// Repository Routes
export const REPOSITORY_LIST = '/repository-integration/';
export const REPOSITORY_DETAILS = (id) => `/repository-integration/${id}/batches/`;
export const REPOSITORY_CREATE = '/repository-integration/';
export const REPOSITORY_UPDATE = (id) => `/repository-integration/${id}/`;
export const REPOSITORY_DELETE = (id) => `/repository-integration/${id}/`;
export const REPOSITORY_EXPLORE = (id, path = '', bucket = '') => {
    let url = `/repository-integration/details/${id}/?path=${path}`;
    if (bucket) {
        url += `&bucket=${encodeURIComponent(bucket)}`;
    }
    return url;
};

export const CREATE_BATCH = '/repository-batch/';
export const BATCH_LIST = '/repository-batch/';
export const BATCH_DETAILS = (batch_id) => `/repository-batch/${batch_id}/`;
export const REPOSITORY_BATCH_FILES = (batch_id) => `/repository-batch/${batch_id}/packages/`;
export const REPOSITORY_LIST_BUCKETS = (id) => `/repository-integration/${id}/list-buckets/`;
export const VERIFY_EMAIL = '/auth/verify-email/';

// CustomGPT
export const ASK_ASSISTANT = '/ai-assistants/ask-assistant/';
export const INITIALIZE_ASSISTANT = '/ai-assistants/initialize-agent/';

// Teams Bot
export const TEAMS_APPS = '/teams-apps/';
export const LLM_MODELS = '/llm-models/';
export const ORGANIZATION = (id) => `/organizations/${id}/`;

// PDF Extraction Download
export const PDF_DOWNLOAD = '/scorm-files/download-extraction-pdf/';

// Administration
export const ADMINISTRATION_USERS = `/users/`;
export const MY_ORGANIZATION = `/organizations/my_organization/`;
